module.exports = __webpack_public_path__ + "static/img/3.70395dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/3.png
// module id = h4eG
// module chunks = 0